const routes = {
  state: {
    active: new Date().valueOf(),
    navIndex: 1,
    // 路由name
    routerName: ''
  },
  mutations: {
    SET_ACTIVE: (state) => {
      let active = new Date().valueOf()
      state.active = active
    },
    SET_NAVINDEX: (state, idx) => {
      state.navIndex = idx
    },
    SET_ROUTERNAME: (state, name) => {
      state.routerName = name
    }
  },
  actions: {
    setActive ({commit}) {
      commit('SET_ACTIVE')
    },
    setNavIndex ({commit}, data) {
      commit('SET_NAVINDEX', data)
    },
    setRouterName ({commit}, data) {
      console.log('set-router-name', data)
      commit('SET_ROUTERNAME', data)
    }
  }
}

export default routes



// WEBPACK FOOTER //
// ./src/stores/modules/routers.js